
class ShopRules {
    // $surcharge_detail: string;
    // $gateway: string;
    // $shopUrl: string;
    // $surcharge_billed_separately: boolean;
    // $surcharge_percentage: number;
    // $gateway_config: any;

    constructor(data) {
        const {cache_compatibility, surcharge_percentage,surcharge_billed_separately, shopUrl, surcharge_detail, gateway, gateway_config } = data;
        this.$surcharge_detail = surcharge_detail || '';
        this.$gateway = gateway;
        this.$shopUrl = shopUrl;
        this.$surcharge_billed_separately = surcharge_billed_separately || false;
        this.$surcharge_percentage = parseInt(surcharge_percentage) || 0;
        this.$cache_compatibility = cache_compatibility || false;
        this.$gateway_config = gateway_config;
    }

    shopUrl()
    {
        return this.$shopUrl;
    }

    surchargePercentage()
    {
        return this.$surcharge_percentage;
    }

    surchargeDetail()
    {
        return this.$surcharge_detail;
    }

    gateway()
    {
        return this.$gateway;
    }

    gatewayConfig()
    {
        return this.$gateway_config;
    }

    /**
     * Whether or not the surcharge is billed separately
     *
     * @returns {boolean}
     */
    surchargeBilledSeparately()
    {
        return this.$surcharge_billed_separately;
    }

    /**
     *
     * @returns {Number}
     */
    surchargeAmount()
    {
        return this.$surcharge_percentage;
    }

    /**
     * Whether or not the cache compatibility mode is enabled 
     *
     * @returns {boolean}
     */
    cacheCompatibilityEnabled()
    {
        return this.$cache_compatibility;
    }

}

export {ShopRules}